import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { GameProvider } from './contexts/GameContext';
import HomePage from './components/HomePage';
import LobbyPage from './components/LobbyPage';
import Room from './components/Room';
import Game from './components/Game';
import ConnectionStatus from './components/ConnectionStatus';
import './App.css';

// 특정 경로에서만 ConnectionStatus를 표시하고 App 클래스에 조건부 패딩을 적용하는 컴포넌트
const ConditionalConnectionStatus = () => {
  const location = useLocation();
  const hideHeaderPaths = ['/'];
  
  if (hideHeaderPaths.includes(location.pathname)) {
    return null;
  }
  
  return <ConnectionStatus />;
};

// 특정 경로에 따라 App에 클래스를 적용하는 컴포넌트
const AppContent = () => {
  const location = useLocation();
  const hideHeaderPaths = ['/'];
  const appClass = hideHeaderPaths.includes(location.pathname) ? 'App no-header' : 'App';
  
  return (
    <div className={appClass}>
      <ConditionalConnectionStatus />
      <div className="version-info">v1.04</div>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/lobby" element={<LobbyPage />} />
        <Route path="/room" element={<Room />} />
        <Route path="/game" element={<Game />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <GameProvider>
      <Router>
        <AppContent />
      </Router>
    </GameProvider>
  );
}

export default App;